import { useEffect } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { Card, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/enhanced-button";

const AuthError = () => {
  const [searchParams] = useSearchParams();
  const error = searchParams.get('error') || 'Authentication failed';
  const errorDescription = searchParams.get('error_description') || 'An unexpected error occurred during the authentication process.';

  useEffect(() => {
    console.error('Authentication Error:', { error, errorDescription });
  }, [error, errorDescription]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-background to-secondary flex items-center justify-center p-4">
      <div className="w-full max-w-md">
        <Card className="border-0 shadow-xl bg-card/95 backdrop-blur-sm">
          <CardContent className="p-8 text-center">
            <div className="mb-8">
              <div className="w-16 h-16 mx-auto mb-4 bg-destructive rounded-xl flex items-center justify-center">
                <svg
                  className="w-10 h-10 text-destructive-foreground"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 5h4v6h-4zm0 8h4v2h-4z" />
                </svg>
              </div>
              <h1 className="text-2xl font-bold text-foreground mb-2">
                Authentication Failed
              </h1>
              <p className="text-muted-foreground mb-4">
                {errorDescription}
              </p>
              {error !== 'Authentication failed' && (
                <p className="text-sm text-muted-foreground/80 mb-4">
                  Error: {error}
                </p>
              )}
            </div>

            <div className="space-y-3">
              <Button
                variant="default"
                size="lg"
                className="w-full"
                asChild
              >
                <Link to="/login">
                  Try Again
                </Link>
              </Button>
              
              <Button
                variant="outline"
                size="lg"
                className="w-full"
                onClick={() => {
                  window.location.href = 'mailto:support@blinkbooks.com?subject=Authentication Issue&body=' + 
                    encodeURIComponent(`I encountered an authentication error:\n\nError: ${error}\nDescription: ${errorDescription}\n\nPlease help resolve this issue.`);
                }}
              >
                Contact Support
              </Button>
            </div>

            <div className="mt-6 pt-6 border-t border-border">
              <p className="text-xs text-muted-foreground">
                If you continue to experience issues, please contact our support team
              </p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AuthError;